export const decodedBase64 = (value?: string) => {
  return decodeURIComponent(escape(window.atob(value || '')));
}
export const encodedBase64 = (data: string) => {
  return window.btoa(unescape(encodeURIComponent(data || '')));
  
}
